import React, { FC } from "react";
import { motion } from "motion/react";

interface Shake {
  active?: boolean;
  children: React.ReactNode;
}

const Shake: FC<Shake> = ({ children, active }) => {
  return (
    <motion.div
      initial={{ x: 0 }}
      animate={active ? { x: [0, -10, 10, -10, 10, 0] } : { x: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};

export default Shake;
